import { LatitudeLongitudeFields } from '@fleet-bffs/api-contract';

export const throttleIntervalMs = 120;
export const minZoom = 1;
export const maxZoom = 25;
export const latBounds = { min: -85, max: 85 };

export const clampLatitude = (lat: number): number =>
  Math.max(latBounds.min, Math.min(latBounds.max, lat));

const normalizeLongitude = (lng: number): number => ((lng + 180) % 360) - 180;

export const normalizeCoordinates = (
  position: LatitudeLongitudeFields
): google.maps.LatLngLiteral | null => {
  const lat = Number(position.latitude);
  const lng = Number(position.longitude);

  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return null;
  }

  return {
    lat: clampLatitude(lat),
    lng: normalizeLongitude(lng),
  };
};

export const normalizeLatLngLiteral = (
  center: google.maps.LatLngLiteral
): google.maps.LatLngLiteral => ({
  lat: clampLatitude(Number(center.lat)),
  lng: normalizeLongitude(Number(center.lng)),
});

export const clampZoom = (zoom: number): number => Math.max(minZoom, Math.min(maxZoom, zoom));
